// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2b2sO","modalFooterButton":"ModalNotes_modalFooterButton__1VEv3"};